import {
    onMounted, onUnmounted, ref, unref, watch, nextTick,
} from 'vue';
import { createNamespacedHelpers, useActions, useStore } from 'vuex-composition-helpers';
import {
    IMapForDatesTabsState,
    IMapForDatesTabsGetters,
    DatesAndPricesItem,
} from '@ve/components/hotel/datesTabs/common/types/IMapForDatesTabsStore';
import registerModule from '@ve/services/registerModule';
import DatesTabsStore from '@ve/components/hotel/datesTabs/common/store/DatesTabsStore';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';

type DatesTabsMutations = {
    addSearchDate(state: IMapForDatesTabsState, date: string): void;
    selectDateManually(state: IMapForDatesTabsState, date: string): void;
};

const mapForDatesTabsStoreName = 'mapForDatesTabs';
const filtersMappingStoreName = 'mapForFilters';

export default () => {
    const store = useStore();
    const hotelTrackingService = new HotelTrackingService();

    registerModule
        .register(store, DatesTabsStore, mapForDatesTabsStoreName);

    const {
        action_selectedTabDate: setSelectedTabDate,
    } = useActions(filtersMappingStoreName, ['action_selectedTabDate']);

    store.watch((state, getters) => getters[`${mapForDatesTabsStoreName}/selectedDate`], (tabDate) => {
        setSelectedTabDate(tabDate);
    });

    const {
        useState, useGetters, useMutations,
    } = createNamespacedHelpers<IMapForDatesTabsState,
        IMapForDatesTabsGetters,
        any,
        DatesTabsMutations>(mapForDatesTabsStoreName);

    const {
        productsAvailable,
        datesAndPrices,
        selectedDate,
        bestPriceDate,
        loadingState,
    } = useGetters(['productsAvailable', 'datesAndPrices', 'selectedDate', 'bestPriceDate', 'loadingState']);

    const {
        searchDates,
        manuallySelectedDate,
    } = useState(['searchDates', 'manuallySelectedDate']);

    const {
        selectDateManually: _selectDateManually,
        addSearchDate,
    } = useMutations(['selectDateManually', 'addSearchDate']);

    const datesTabsContent = ref();
    const containerWidth = ref(0);
    const itemWidth = ref(0);

    const _updateOnResize = () => {
        const productsAvailableValue = unref(productsAvailable);
        if (productsAvailableValue) {
            const el = unref(datesTabsContent) as HTMLElement;
            containerWidth.value = el.offsetWidth;
            itemWidth.value = (el.children[0] as HTMLElement).offsetWidth;
        }
    };
    watch(productsAvailable, () => nextTick(_updateOnResize));

    onMounted(() => {
        window.addEventListener('resize', _updateOnResize);
    });
    onUnmounted(() => {
        window.removeEventListener('resize', _updateOnResize);
    });

    const selectTabDate = (tabData: DatesAndPricesItem) => {
        hotelTrackingService.datesTabsClick(!!tabData.price);
        addSearchDate(tabData.startDate);
        _selectDateManually(tabData.startDate);
    };

    return {
        productsAvailable,
        datesAndPrices,
        selectedDate,
        datesTabsContent,
        containerWidth,
        itemWidth,
        bestPriceDate,
        selectTabDate,
        searchDates,
        manuallySelectedDate,
        loadingState,
    };
};